import React, { useState, useEffect } from 'react';
import HeaderCardNew from '../../Components/HeaderCardNew';
import FlexibleCard from '../../Components/FlexibleCard';
import CarouselSmallCard from '../../Components/CarouselSmallCard';
import CallToActionCard from '../../Components/CallToActionCard';
import FeedbackCard from '../../Components/FeedbackCard';
import BannerCard from '../../Components/BannerCard';
import TopNavBarNew from "../../Components/TopNavBarNew";
import BottomNavBarNew from "../../Components/BottomNavBarNew";
import styles from './PillAbortion.module.css';

export default function PillAbortionDuringOne({ appLanguage }) {
  const [pageState, setPageState] = useState({
    // General Content
    headerTitle: '',
    extraText: '',
    extraText2: '',
    extraText3: '',
    narrowCardTitle1: '',
    narrowCardTitle2: '',
    narrowCardTitle3: '',

    // Individual Large Cards
    largeCard1: {},
    largeCard2: {},
    largeCard3: {},
    largeCard4: {},
    largeCard5: {},
    largeCard6: {},
    largeCard7: {},
    largeCard8: {},
    largeCard9: {},
    largeCardTitle10: '',

    // Small Cards Section
    smallCardTitle1: '',
    smallCardDescription1: '',
    smallCardTitle2: '',
    smallCardDescription2: '',
    smallCardTitle3: '',
    smallCardDescription3: '',

    // Banner Card
    bannerCardDescription1: '',
    bannerCardTitle1: '',

    // Assets
    headerImage: '',
    arrowIconWhite: '',
    arrowIconDark: '',
    heartIcon: '',
    image1: '',
    image2: '',
    image3:'',
    audioSrc: '',
    audioTitle: 'Uso de mifepristona y misoprostol',
  });

  const [isAudioModalOpen, setIsAudioModalOpen] = useState(false);

  useEffect(() => {
    // Scroll to top of the page and set the document title
    window.scrollTo(0, 0);
    document.title = 'Pill Abortion During One';

    // Direct localStorage reading
    const entries = JSON.parse(localStorage.getItem('ayaAppEntries') || '[]');
    const assets = JSON.parse(localStorage.getItem('ayaAppAssets') || '[]');

    // Helper functions
    const getEntryField = (entryId, field, language = appLanguage || 'es-VE') => {
      const entry = entries.find(e => e.sys.id === entryId);
      if (!entry?.fields?.[field]) return '';
      
      const fieldValue = entry.fields[field];
      if (typeof fieldValue === 'object' && fieldValue[language]) {
        return fieldValue[language];
      }
      return fieldValue;
    };

    const getAssetUrl = (assetId, language = appLanguage || 'es-VE') => {
      const asset = assets.find(a => a.sys.id === assetId);
      if (!asset?.fields?.file) return '';
      
      // Try localized file first
      const localizedFile = asset.fields.file[language];
      if (localizedFile?.url) {
        const url = localizedFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }
      
      // Fallback to any available file
      const fallbackFile = Object.values(asset.fields.file)[0];
      if (fallbackFile?.url) {
        const url = fallbackFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }
      
      return '';
    };

    // Define entry IDs
    const abortionEntryId = '4rvqxu6rFLHCEDeSD9c7DU';
    const largeCardEntryId = '2TWM7dx8EAjwjQv0xZvrqc';

    // Set state for the various sections of the page
    setPageState({
      // General Content for the page
      headerTitle: getEntryField(abortionEntryId, 'headerTitle') || '',
      extraText: getEntryField(abortionEntryId, 'extraText') || '',
      extraText2: getEntryField(abortionEntryId, 'extraText2') || '',
      extraText3: getEntryField(abortionEntryId, 'extraText3') || '',
      narrowCardTitle1: getEntryField(abortionEntryId, 'narrowCardTitle1') || '',
      narrowCardTitle2: getEntryField(abortionEntryId, 'narrowCardTitle2') || '',
      narrowCardTitle3: getEntryField(abortionEntryId, 'narrowCardTitle3') || '',
      audioSrc: getAssetUrl('5mLqLCoBWtX68bPVeKIokz') || '',

      // Banner Card
      bannerCardDescription1: getEntryField(abortionEntryId, 'bannerCardDescription1') || '',
      bannerCardTitle1: getEntryField(abortionEntryId, 'bannerCardTitle1') || '',

      // Small Cards Section
      smallCardTitle1: getEntryField(abortionEntryId, 'smallCardTitle1') || '',
      smallCardDescription1: getEntryField(abortionEntryId, 'smallCardDescription1') || '',
      smallCardTitle2: getEntryField(abortionEntryId, 'smallCardTitle2') || '',
      smallCardDescription2: getEntryField(abortionEntryId, 'smallCardDescription2') || '',
      smallCardTitle3: getEntryField(abortionEntryId, 'smallCardTitle3') || '',
      smallCardDescription3: getEntryField(abortionEntryId, 'smallCardDrescription3') || '',

      // Individual Large Cards
      largeCard1: {
        ovalText: getEntryField(largeCardEntryId, 'largeCardTitle10') || '',
        blueTitle: getEntryField(largeCardEntryId, 'largeCardTitle1') || '',
        description: getEntryField(largeCardEntryId, 'largeCardDescription1') || '',
        images: [{ url: getAssetUrl('42cWjtvnExoP6BwEni5bgZ') || '' }],
      },
      largeCard2: {
        blackTitle: getEntryField(largeCardEntryId, 'largeCardTitle2') || '',
        description: getEntryField(largeCardEntryId, 'largeCardDescription2') || '',
        images: [
          {
            url: getAssetUrl('42cWjtvnExoP6BwEni5bgZ') || '',
          },
        ],
      },
      largeCard3: {
        blackTitle: getEntryField(largeCardEntryId, 'largeCardTitle3') || '',
        description: getEntryField(largeCardEntryId, 'largeCardDescription3') || '',
      },
      largeCard4: {
        blackTitle: getEntryField(largeCardEntryId, 'largeCardTitle4') || '',
        description: getEntryField(largeCardEntryId, 'largeCardDescription4') || '',
        description2: getEntryField(largeCardEntryId, 'largeCardDescription5') || '',
        images: [
          {
            url: getAssetUrl('2eOBY4dpOn2ovcu6DNBzig') || '',
          },
        ],
      },
      largeCard5: {
        blackTitle: getEntryField(largeCardEntryId, 'largeCardTitle5') || '',
        description: getEntryField(largeCardEntryId, 'largeCardDescription6') || '',
      },
      largeCard6: {
        blackTitle: getEntryField(largeCardEntryId, 'largeCardTitle6') || '',
        description: getEntryField(largeCardEntryId, 'largeCardDescription7') || '',
      },      
      largeCard7: {
        blackTitle: getEntryField(largeCardEntryId, 'largeCardTitle7') || '',
        description: getEntryField(largeCardEntryId, 'largeCardDescription8') || '',
      },
      largeCard8: {
        blackTitle: getEntryField(largeCardEntryId, 'largeCardTitle8') || '',
        description: getEntryField(largeCardEntryId, 'largeCardDescription9') || '',
      },
      largeCard9: {
        blackTitle: getEntryField(largeCardEntryId, 'largeCardTitle9') || '',
        description: getEntryField(largeCardEntryId, 'largeCardDescription10') || '',
      },

      // Assets
      headerImage: getAssetUrl('01OKOkJKnkhbdVZXksKyej') || '',
      arrowIconWhite: getAssetUrl('5t0SZSeDrtBlIZ3o0Apjcu') || '',
      arrowIconDark: getAssetUrl('35s9SZBtTGy9KGs0lc41lt') || '',
      heartIcon: getAssetUrl('740H3V1s40GxiaZiqj79MY') || '',
      image3: getAssetUrl('y3Rd7KceR170l23wC9ZX9') || '',
    });
  }, [appLanguage]);

  return (
    <div className={styles.libraryAbortionMenuContainer}>
    <TopNavBarNew backgroundColor="#FDE8D8" breadcrumbColor="#333" />
      {/* Header Section */}
      <div className={styles.headerContainer2}>
        <HeaderCardNew
          title={pageState.headerTitle}
          image={pageState.headerImage}
          backgroundColor="#FDE8D8"
          borderRadius="0px"
        />
        <div className={styles.bottomSpaceHeader}></div>
     
      </div>
      <div className={styles.homePageContainer}>

        {/* Render Individual Large Cards */}
        <FlexibleCard
          blueTitle={pageState.largeCard1.blueTitle}
          blueTitleWidth="213px"
          description={pageState.largeCard1.description}
          showOval={true}
          ovalText={pageState.largeCard1.ovalText}
          width="351px"
          borderRadius="10px"
        />


        {/* Render Individual Large Cards */}
        <FlexibleCard   
          description={pageState.largeCard2.description}
          blackTitle={pageState.largeCard2.blackTitle}
          images={pageState.largeCard2.images}
          imagePosition="below-description"
          imageWidth="146px"
          width="351px"
          height="270px"
          borderRadius="10px"
        />

        {/* Call To Action Card 2 */}
        <CallToActionCard
          title={pageState.narrowCardTitle1}
          icon={pageState.arrowIconWhite}
          showIcon={false}
          isLink={true}
          buttonLink="#"
          useCardGradient={true}
          titleColor="#fff"
          cardColor='#4350E6'
          cardGradient = 'linear-gradient(90deg, #4350E6 0%, #4350E6 100%)'
          width="357px"
          height="41px"
          iconPosition="right" 
          borderRadius="10px"
          // Custom Font Settings
          titleFont="Inter"
          titleFontSize="13px"
          titleFontWeight="400"
          
        />

        <FlexibleCard
          blackTitle={pageState.largeCard3.blackTitle}
          description={pageState.largeCard3.description}
          width="351px"
          borderRadius="10px"
        />

        {/* Call To Action Card 2 */}
        <CallToActionCard
          title={pageState.narrowCardTitle2}
          icon={pageState.arrowIconWhite}
          showIcon={false}
          isLink={true}
          buttonLink="#"
          useCardGradient={true}
          titleColor="#fff"
          cardColor='#4350E6'
          cardGradient = 'linear-gradient(90deg, #4350E6 0%, #4350E6 100%)'
          width="357px"
          height="41px"
          iconPosition="right" 
          borderRadius="10px"
          // Custom Font Settings
          titleFont="Inter"
          titleFontSize="13px"
          titleFontWeight="400"
          className="noPointerCursor" 
        />

        <FlexibleCard
          blackTitle={pageState.largeCard4.blackTitle}
          description={pageState.largeCard4.description}
          description2={pageState.largeCard4.description2}
          images={pageState.largeCard4.images}
          imageWidth="228px"
          imagePosition="below-first-description"
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          blackTitle={pageState.largeCard5.blackTitle}
          description={pageState.largeCard5.description}
          images={pageState.largeCard5.images}
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          blackTitle={pageState.largeCard6.blackTitle}
          description={pageState.largeCard6.description}
          images={pageState.largeCard6.images}
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          blackTitle={pageState.largeCard7.blackTitle}
          description={pageState.largeCard7.description}
          images={pageState.largeCard7.images}
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          blackTitle={pageState.largeCard8.blackTitle}
          description={pageState.largeCard8.description}
          images={pageState.largeCard8.images}
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          blackTitle={pageState.largeCard9.blackTitle}
          description={pageState.largeCard9.description}
          images={pageState.largeCard9.images}
          width="351px"
          borderRadius="10px"
        />

        {/* Call To Action Card - Tracker */}
{/*         <CallToActionCard
          title={pageState.narrowCardTitle3}
          icon={pageState.arrowIconWhite}
          showIcon={true}
          isLink={true}
          buttonLink="/tracker-onboarding-welcome"
          useCardGradient={true}
          titleColor="#fff"
          cardGradient="linear-gradient(90deg, #E12541 0%, #F85833 100%)"
          width="356px"
          height="52px"
          iconPosition="right" 
          borderRadius="10px"
          titleFont="Inter"
          titleFontSize="13px"
          titleFontWeight="400"
        />
 */}
        <BannerCard 
        title={pageState.bannerCardTitle1} 
        description={pageState.bannerCardDescription1}
        image={pageState.image3}
        gradient="linear-gradient(99deg, #4450E5 22.9%, #616CEE 77.43%)"
        link="/chat-main"
        imageWidth="81px"
        imageHeight="80px"
        imagePosition="top-right"
        imageOffsetY=""
        imageOffsetX=""
        titleMaxWidth="256px"
        descriptionMaxWidth="286px"
        cardWidth="349px"
        cardHeight="88px"
        />

        {/* Extra Text Section */}
        <div className={styles.extraTitle}>{pageState.extraText}</div>

        {/* Feedback Card Section */}
        <FeedbackCard title={pageState.extraText3} appLanguage={appLanguage} />

        <div className={styles.leftAlignWrapper}>

        {/* Extra Text Section */}
        <div className={styles.extraTitletwo}>{pageState.extraText2}</div>

                {/* Render Small Cards Section */}
                {pageState.smallCardTitle1 && (
          <div className={styles.carouselContainer}>
            <CarouselSmallCard
              title={pageState.smallCardTitle1}
              extraText={pageState.smallCardDescription1}
              icon={pageState.arrowIconDark}
              link="/abor-during-usemiso"
            />
            <CarouselSmallCard
              title={pageState.smallCardTitle2}
              extraText={pageState.smallCardDescription2}
              icon={pageState.arrowIconDark}
              link="/abor-during-warningsigns"
            />
 {/*            <CarouselSmallCard
              title={pageState.smallCardTitle3}
              extraText={pageState.smallCardDescription2}
              icon={pageState.arrowIconDark}
              link="/abor-after-managingemotions"
            /> */}
          </div>
        )}

      </div>
      </div>
      <div className={styles.bottomSpace}></div>
      <BottomNavBarNew appLanguage={appLanguage}/>
    </div>
  );
}